import React from "react";
import { Glyphicon } from "react-bootstrap";


export default ({ painter, i, me }) => <div key={i} >
	{painter.userCreated.userEmail} {painter.userCreated.userEmail === me && <b>(me)</b>} : <span style={{ color: painter.isCorrect ? "green" : "red" }}>
		{painter.isCorrect ? <Glyphicon glyph="ok-circle" /> : <Glyphicon glyph="remove-circle" />}</span>
</div>